const DRAFT_PREFIX = 'kwc:pattern-admin:draft:v1';

export function getPatternDraftKey(patternId) {
  return `${DRAFT_PREFIX}:${patternId || 'new'}`;
}

function isLocalFile(value) {
  return typeof File !== 'undefined' && value instanceof File;
}

function isPersistableUrl(value) {
  return typeof value === 'string' && !value.startsWith('blob:');
}

export function createPatternDraft({ formData, images, mainImage, pdfFiles }, now = new Date()) {
  const imageUrls = images.filter(isPersistableUrl);
  const persistedPdfs = pdfFiles
    .filter((item) => item && isPersistableUrl(item.url))
    .map((item) => ({
      url: item.url,
      language: item.language || '',
      name: item.name || 'PDF File',
    }));

  const attachmentNames = [
    ...images.filter(isLocalFile).map((file) => file.name),
    ...pdfFiles.filter((item) => item?.file && isLocalFile(item.file)).map((item) => item.file.name),
  ];

  return {
    version: 1,
    savedAt: now.toISOString(),
    attachmentNames,
    formData: {
      ...formData,
      images: imageUrls,
      main_image: isPersistableUrl(mainImage) ? mainImage : (imageUrls[0] || ''),
      pdf_files: persistedPdfs,
    },
  };
}

export function savePatternDraft(storage, key, draftData) {
  try {
    storage?.setItem(key, JSON.stringify(createPatternDraft(draftData)));
    return true;
  } catch {
    return false;
  }
}

export function loadPatternDraft(storage, key) {
  try {
    const value = storage?.getItem(key);
    if (!value) return null;

    const draft = JSON.parse(value);
    if (draft?.version !== 1 || !draft.formData || typeof draft.formData !== 'object') {
      return null;
    }

    return draft;
  } catch {
    return null;
  }
}

export function clearPatternDraft(storage, key) {
  try {
    storage?.removeItem(key);
  } catch {
    // A blocked storage API should never prevent editing or saving a pattern.
  }
}
